import CheckoutGuest from './CheckoutGuest'

export default CheckoutGuest
